export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const normalizeEmail = (email: string): string =>
  email.trim().toLowerCase();

export const isValidEmail = (email: string): boolean =>
  EMAIL_PATTERN.test(normalizeEmail(email));

export const normalizeEmailList = (emails?: string[]): string[] | undefined => {
  if (!emails) return undefined;

  return emails.map(normalizeEmail).filter(Boolean);
};

export const uniqueNormalizedEmailList = (
  emails?: string[],
): string[] | undefined => {
  const normalizedEmails = normalizeEmailList(emails);
  if (!normalizedEmails) return undefined;

  return normalizedEmails.filter(
    (email, index) => normalizedEmails.indexOf(email) === index,
  );
};

export const findInvalidEmail = (emails?: string[]): string | undefined =>
  normalizeEmailList(emails)?.find((email) => !isValidEmail(email));

export const hasDuplicateNormalizedEmail = (emails?: string[]): boolean => {
  const seen = new Set<string>();

  for (const email of normalizeEmailList(emails) ?? []) {
    if (seen.has(email)) return true;
    seen.add(email);
  }

  return false;
};
